import type { ScoutQuestionCommand } from "providers/ChatSurfaceCoordinator";

import { useEffect, useRef } from "react";

/**
 * Consumes each coordinator command once. The command id—not question text—is
 * the identity so closing and asking the same question again still works.
 */
export function useScoutPopoverStarterQuestion({
  open,
  conversationId,
  command,
  onAsk,
  onConsumed,
}: {
  open: boolean;
  conversationId: string | undefined;
  command: ScoutQuestionCommand | undefined;
  onAsk: (command: ScoutQuestionCommand) => void;
  onConsumed: (requestId: number) => void;
}) {
  const consumedRequestIdRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (!open || !command || conversationId) {
      return;
    }
    if (consumedRequestIdRef.current === command.requestId) {
      return;
    }
    consumedRequestIdRef.current = command.requestId;
    onAsk(command);
    onConsumed(command.requestId);
  }, [command, conversationId, onAsk, onConsumed, open]);
}
